import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import c from 'classnames'

import { getEvoxImage } from 'actions/inventoryActions'
import { GET } from 'actions/apiActions'
import placeholderImg from 'static/images/silhouette.png'

export const VehicleImage = ({
  className,
  year,
  make,
  model,
  trim,
  getEvoxImage,
  children,
}) => {
  let [image, setImage] = useState(),
    alt = [year, make, model, trim].filter(x => x).join(' ')

  useEffect(() => {
    if (year && make && model) {
      getEvoxImage({ year, make, model })
        .then(({ fullsize_path }) => setImage(fullsize_path))
        .catch(() => setImage(null))
    }
  }, [year, make, model, setImage, getEvoxImage])

  return (
    <div
      className={c('trade-image', className, {
        'has-image': !!image,
      })}
      style={{ backgroundImage: `url(${image || placeholderImg})` }}
    >
      {children}
    </div>
  )
}

export default connect(
  op => op,
  { getEvoxImage },
)(VehicleImage)
